export const UpgradeMessage = "cCa";
export default {UpgradeMessage};